import { ArrowUpDown } from "lucide-react"
import { Button } from "@/components/ui/button"
import { Badge } from "@/components/ui/badge"
import { TalentType } from "./types"

type TalentListProps = {
  talents: TalentType[]
  onViewProfile: (id: string) => void
}

export function TalentList({ talents, onViewProfile }: TalentListProps) {
  return (
    <div className="border rounded-lg overflow-hidden">
      <table className="min-w-full divide-y">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              <div className="flex items-center gap-1">
                Name
                <ArrowUpDown size={14} />
              </div>
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Level
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Skills
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Status
            </th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
              Last Updated
            </th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y">
          {talents.map(talent => (
            <tr key={talent.id} className="hover:bg-gray-50">
              <td className="px-6 py-4">
                <div>
                  <p className="font-medium">{talent.name}</p>
                  <p className="text-sm text-gray-500">{talent.email}</p>
                </div>
              </td>
              <td className="px-6 py-4">{talent.level}</td>
              <td className="px-6 py-4">
                <div className="flex flex-wrap gap-1">
                  {talent.skills.slice(0, 2).map(skill => (
                    <Badge key={skill} variant="outline" className="text-xs">
                      {skill}
                    </Badge>
                  ))}
                  {talent.skills.length > 2 && (
                    <Badge variant="outline" className="text-xs">
                      +{talent.skills.length - 2}
                    </Badge>
                  )}
                </div>
              </td>
              <td className="px-6 py-4">
                <Badge className={
                  talent.status === "Available" 
                    ? "bg-green-100 text-green-800" 
                    : talent.status === "In process" 
                      ? "bg-blue-100 text-blue-800" 
                      : "bg-gray-100 text-gray-800"
                }>
                  {talent.status}
                </Badge>
              </td>
              <td className="px-6 py-4 text-sm">{talent.lastUpdated}</td>
              <td className="px-6 py-4 text-right">
                <Button variant="ghost" size="sm" onClick={() => onViewProfile(talent._id)}>
                  View
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
} 